import { handleActions } from 'redux-actions';
import { UPDATE_WINDOW_SIZE } from 'widget/redux/client/actions/window-size';

const defaultState = {
  width: window.innerWidth,
  height: window.innerHeight,
};

export default handleActions(
  {
    [UPDATE_WINDOW_SIZE]: (state, { payload }) => ({ ...state, ...payload }),
  },
  defaultState,
);
